import { WebSocketEntityUpdateInterface } from '@/utils/websocket-entity-updates/webSocketEntityUpdates.types';
import { store } from '@/redux/store';
import { ENTITY_OPERATION_TYPES } from '@/utils/websocket-entity-updates/webSocketEntityUpdates.constants';
import { getReaction } from '@/redux/reactions/reactions.thunks';
import { reactionDelete, reactionUpdate } from '@/redux/reactions/reactions.slice';

export default async function processReaction({
  data,
}: {
  data: WebSocketEntityUpdateInterface;
}): Promise<void> {
  const { dispatch } = store;
  if (
    data.type === ENTITY_OPERATION_TYPES.ENTITY_CREATED ||
    data.type === ENTITY_OPERATION_TYPES.ENTITY_UPDATED
  ) {
    const reaction = await dispatch(
      getReaction({ modelId: data.mapId, reactionId: data.entityId }),
    ).unwrap();
    if (!reaction) {
      return;
    }
    dispatch(reactionUpdate({ modelId: data.mapId, reaction }));
  } else if (data.type === ENTITY_OPERATION_TYPES.ENTITY_DELETED) {
    dispatch(reactionDelete({ modelId: data.mapId, reactionId: data.entityId }));
  }
}
